var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',_vm._b({ref:"link-button",class:{
    'h-[38px] px-4 flex items-center rounded-lg border whitespace-nowrap': true,
    'border-transparent bg-green-700 hover:bg-green-600': _vm.variant === 'primary',
    'border-green-700': _vm.variant === 'secondary',
    'border-transparent': _vm.variant === 'tertiary'
  },attrs:{"to":_vm.href,"target":_vm.newTab ? '_blank' : null}},'router-link',_vm.$attrs,false),[_c('div',{staticClass:"flex items-center gap-3"},[_vm._t("icon-left"),_vm._t("default"),_vm._t("icon-right")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }